import { Snackbar } from "@mui/material";
import { useState } from "react";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import styled from "@emotion/styled";

const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
  top: 0,
  "@media (min-width: 600px)": {
    top: 0,
  },
}));

const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  color: "#4a4f54",
  //fontSize: 14,
}));

const useStyles = makeStyles({
  contentWrapper: {
    padding: "24px",
    width: "100%",
    background: "#fff5e7",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  rightClose: {
    marginLeft: 16,
    display: "flex",
    alignItems: "center",
  },
});

const wrapperStyle = {
  width: "100vw",
  left: 0,
  right: 0,
};

const AlertBase = (props) => {
  const { content, duration, onClose, isFullWidth } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleCloseMessage = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <StyledSnackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      sx={isFullWidth ? wrapperStyle : {}}
      open={open}
      autoHideDuration={duration}
    >
      <div
        className={classes.contentWrapper}
        style={{ borderRadius: isFullWidth ? 0 : 12 }}
      >
        {content}
        <div className={classes.rightClose} onClick={handleCloseMessage}>
          <StyledCloseIcon style={{ fontSize: isFullWidth ? 18 : 16 }} />
        </div>
      </div>
    </StyledSnackbar>
  );
};

export default AlertBase;
